import React from 'react'
import { Link, Navigate } from 'react-router-dom'
import { AuthForm } from '../../../../components/AuthForm/AuthForm'
import { LoadingForm } from '../../../../components/LoadingForm/LoadingForm'
import { VerifyEmail } from '../../../../components/VerifyEmail/VerifyEmail'
import { ROUTES } from '../../../../constants/routes'
import { useRouter } from '../../../../hooks/useRouter'
import { AccountStep } from './components/AccountStep'
import { useSignupUser } from './hooks/useSignupUser'
import { useSignupWizard } from './hooks/useSignupWizard'

export const Signup = (): React.ReactElement => {
  const { location } = useRouter()
  const { user, isLoading, error, handleCreate, handleVerifyEmail, handleResendVerifyEmail } =
    useSignupUser()
  const { step, steps, nextStep, previousStep } = useSignupWizard()

  const handlePreviousVerifyEmail = async () => {
    previousStep()
  }

  if (isLoading) {
    return (
      <AuthForm useProgress={true} totalSteps={steps.length}>
        <LoadingForm />
      </AuthForm>
    )
  }

  if (!!user?.is_email_verified) {
    return <Navigate to={{ pathname: ROUTES.SETUP, search: location.search }} replace />
  }

  return (
    <AuthForm
      useProgress={true}
      totalSteps={steps.length}
      currentStep={steps.findIndex((s) => s === step) + 1}
      error={error}
      cardFooter={
        <>
          {step === 'account' && (
            <>
              {!user && (
                <span className="d-block w-100 text-center">
                  <Link to={{ pathname: ROUTES.LOGIN, search: location.search }} className="ms-2">
                    Have an account? Login
                  </Link>
                </span>
              )}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={process.env.REACT_APP_REGISTER_URL}
                className="d-block w-100 mt-3 text-center"
              >
                Not looking to start your own program? Click here to register for one
              </a>
            </>
          )}
        </>
      }
    >
      {step === 'account' && (
        <AccountStep
          initialValues={user}
          onSubmit={async (value) => {
            await handleCreate(value)
            nextStep()
          }}
        />
      )}
      {step === 'verify_email' && (
        <VerifyEmail
          has_error={!!error}
          onResend={handleResendVerifyEmail}
          onPrevious={handlePreviousVerifyEmail}
          onComplete={handleVerifyEmail}
        />
      )}
    </AuthForm>
  )
}
